var map = {
	"./de-DE/dataset-hit-testing": 40270,
	"./en-US/dataset-hit-testing": 35749,
	"./es-ES/dataset-hit-testing": 37456,
	"./fa-IR/dataset-hit-testing": 80648,
	"./fr-FR/dataset-hit-testing": 73676,
	"./hi-IN/dataset-hit-testing": 11694,
	"./it-IT/dataset-hit-testing": 33734,
	"./ja-JP/dataset-hit-testing": 33109,
	"./ko-KR/dataset-hit-testing": 95399,
	"./pl-PL/dataset-hit-testing": 52688,
	"./pt-BR/dataset-hit-testing": 9480,
	"./ro-RO/dataset-hit-testing": 64614,
	"./ru-RU/dataset-hit-testing": 53706,
	"./sl-SI/dataset-hit-testing": 82157,
	"./th-TH/dataset-hit-testing": 95320,
	"./tr-TR/dataset-hit-testing": 74520,
	"./uk-UA/dataset-hit-testing": 64086,
	"./vi-VN/dataset-hit-testing": 39451,
	"./zh-Hans/dataset-hit-testing": 29162,
	"./zh-Hant/dataset-hit-testing": 18939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7086;